import { getBaseURL, getLastItemOfPath, getURLWithPath } from "../../AcademyUtilities";
import { HideLoader, ShowLoader } from "../../Components/Loader";

$(function () {
    let CurrentRegistrationVM = []; //Used for holding data for back button
    function transformBaseURLForRegistration() {
        if (getLastItemOfPath().toLowerCase() === "register") {
            return getURLWithPath().toLowerCase().replace("register", "registration")
        }
        return getURLWithPath();
    }

    const RegistrationParent = $('#registration-parent');
    const SubmitButton = $('#RegistrationSubmit');
    const ResponseElement = $('#ErrorResponses');
    const RegistrationCurrentView = $('#RegistrationCurrentView');
    const AntiForgeryToken = $('input:hidden[name="__RequestVerificationToken"]').val();


    bindEvents();

    if ($("#CurrentView").val() !== 'RegistrationResults') {
        GetNextRegistrationView($('#registration-form').serialize());
    }

    $(window).on("popstate", function (event) {
        //If there is a state stored in the array, go back to that view
        handleBack();
    });



    const Field = $('.form-control');
    Field.on('input', function () {
        setFirstEnterKeyEvent();
    });

    function setFirstEnterKeyEvent() {
        //let enter click continue
        $(document).off();
        $(document).on('keypress', function (e) {
            if (e.key === "Enter") {
                if (!SubmitButton.is(":disabled")) {
                    submitForm();
                }
            }
        });
    }

    function detectAndEnforceOrgLock(data: any) {
        if ($(data).find('#AccountFormVM_Affiliated').length > 0 && $(data).find('#AccountFormVM_Affiliated').is(':checked')) {
            $('div.school-org-info').toggle();
            $('#AccountFormVM_Affiliated').attr('disabled', 'true');
        }
    }

    function handleBackToAccount(data: any) {
        detectAndEnforceOrgLock(data);

        if ($(data).find('#AccountFormVM_OrgCountry').length > 0 && $(data).find('#AccountFormVM_OrgCountry').val() == 'US') {
            $('#AccountFormVM_OrgUsState').removeAttr('disabled');
            $('#OrgUsStateBlock').show();
        }
    }

    function GetPreviousView(RegistrationVM) {

        ShowLoader();
        $.ajax(
            {
                type: 'POST',
                url: transformBaseURLForRegistration() + '/Register/?handler=GetPreviousView',
                data: RegistrationVM,
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                async: true,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("XSRF-TOKEN",
                        AntiForgeryToken as string);
                }
            }).fail(function (data) {
                alert("Something went wrong. Please try again. If the problem persists please contact customer support.");
            })
            .done(function (data) { 
                RegistrationCurrentView.html("");
                RegistrationCurrentView.html(data);
                $('#registration-form').validate().destroy();
                $.validator.unobtrusive.parse($('#registration-form'));
                
                handleBackToAccount(data);
            }).always(function (data) {
                HideLoader();
            });
    }

    function submitForm() {
        const ConfirmedLogin = $('#ConfirmedLogin');
        if (ConfirmedLogin.length != 0) {
            ConfirmedLogin.val('true');
        }
        const AffiliatedField = $('#AccountFormVM_Affiliated');
        ClearErrors();
        var registrationForm = $('#registration-form');

        const formContainsAffiliated = AffiliatedField.length > 0; 
        const lockAffiliated = formContainsAffiliated ? AffiliatedField.is(':disabled'): false;
        SubmitButton.prop('disabled', true);

        if (AffiliatedField.length > 0 && AffiliatedField.is(':disabled')) {
            AffiliatedField.removeAttr('disabled');
        }
        registrationForm.validate();

        if (!registrationForm.valid()) {
            SubmitButton.prop('disabled', false);

            if (formContainsAffiliated && lockAffiliated) {
                AffiliatedField.prop('disabled', lockAffiliated);
            }
            return;
        }
        ShowLoader();

        var RegistrationVM = registrationForm.serialize();

        $.ajax(
            {
                type: 'POST',
                url: transformBaseURLForRegistration() + '/Register/?handler=RegistrationForm',
                data: RegistrationVM,
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                async: true,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("XSRF-TOKEN",
                        AntiForgeryToken as string);
                }
            }).fail(function (data) {
                SubmitButton.prop('disabled', false);
                alert("Something went wrong. Please double check the access code provided is a valid access code and try again.");
            })
            .done(function (data) { 
                HandleRegistrationResult(data)
            }).always(function (data) {
                HideLoader();
            });
    }

    function HandleRegistrationResult(data) {
 
        if (data.statusCode == 200) {
            history.pushState(data.registrationVM, null, null);
            CurrentRegistrationVM.push(data.registrationVM);
      
            GetNextRegistrationView(data.registrationVM);
        } else { 
            DisplayErrors(data);
        }
    } 

    function handleKeypress(event) {
        if (event.which === 13) {
            event.preventDefault();
            $('#RegistrationSubmit').trigger('click');
        }
    }

    function DisplayErrors(data) {
        SubmitButton.prop('disabled', false);
        ResponseElement.html(data.message);
        ResponseElement.addClass("alert");
        ResponseElement.addClass("alert-warning");
    }
    function ClearErrors() { 
        ResponseElement.html("");
        ResponseElement.removeClass("alert");
        ResponseElement.removeClass("alert-warning");
    }
    function handlePreFilledAccessCode(data: any) {
        if ($(data).find('#AccessCodeVM_AccessCode[type="text"]').length > 0) {
            if ($(data).find('#AccessCodeVM_AccessCode[type="text"]').val() != '') {
                ShowLoader();
                $('#RegistrationSubmit').trigger('click');
                RegistrationCurrentView.html("");
            }
        }
    }
    function GetNextRegistrationView(RegistrationVM) {
        
        ShowLoader();
   
        $.ajax(
            {
                type: 'POST',
                url: transformBaseURLForRegistration() + '/Register/?handler=GetNextView',
                data: RegistrationVM,
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                async: true,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("XSRF-TOKEN",
                        AntiForgeryToken as string);
                }
            }).fail(function (data) {
                alert("Something went wrong. Please try again. If the problem persists please contact customer support.");
            })
            .done(function (data) {
                RegistrationCurrentView.html("");
                RegistrationCurrentView.html(data);
                detectAndEnforceOrgLock(data);
                $('#registration-form').validate().destroy();
                $.validator.unobtrusive.parse($('#registration-form'));
                //Reset field validation.
                $('.field-validation-error').removeClass('field-validation-error').addClass('field-validation-valid').html('');
            }).always(function (data) {
                HideLoader();
                handlePreFilledAccessCode(data);
            });
    } 
    function handleBack() {

        if (CurrentRegistrationVM && CurrentRegistrationVM.length > 0) {
     
            var RegistrationVM = CurrentRegistrationVM.pop();
           
            if (RegistrationVM.currentView
                && RegistrationVM.currentView !== ""
                && RegistrationVM.currentView.toLowerCase() !== "registrationresults") {

                GetPreviousView(RegistrationVM);
                return;
            }
        }
        history.back(); 
    } 
    function goBackToStart() { 
        window.location.replace(getURLWithPath());
    }
    function signIn() { 
        var redirectUrl = $('#signInButton').attr("data-returnurl");
        window.location.href = `${getBaseURL()}Account/Login?returnUrl=${redirectUrl}`;
    }
    function removeWhitespace() {
        $(this).val(function (_, v) {
            return v.replace(/\s+/g, '');
        });
    }
    function bindEvents() { 
        RegistrationParent.on('click', '#signInButton', signIn);
        RegistrationParent.on('click', '#startOverButton', goBackToStart);
        RegistrationParent.on('click', '#previousViewButton', handleBack);
        RegistrationParent.on('click', '#RegistrationSubmit', submitForm);
        RegistrationParent.on('input', '#AccessCodeVM_AccessCode', removeWhitespace)
        RegistrationParent.on('keypress', handleKeypress)
    }  
}); 